import * as React from 'react';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

const FooterWrapper = styled.div`
  display: block;
  background-color: #ffff;
`;

const FooterContainer = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 80px 0 50px 0;
  margin-right: auto;
  margin-left: auto;
  max-width: 960px;
  @media only screen and (max-width: 991px) {
    padding: 50px 0 30px 0;
    text-align: center;
  }
  @media (max-width: 1199px) {
    max-width: 720px;
  }
`;

const Row = styled.div`
  box-sizing: border-box;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -ms-flex: 0 1 auto;
  -webkit-box-flex: 0;
  -webkit-flex: 0 1 auto;
  flex: 0 1 auto;
  -ms-flex-direction: row;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  flex-direction: row;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -9px;
  margin-left: -9px;
`;

const LogoAppColumn = styled.div`
  -ms-flex-preferred-size: 100%;
  -webkit-flex-basis: 100%;
  flex-basis: 100%;
  max-width: 100%;

  @media only screen and (min-width: 992px) {
    -ms-flex-preferred-size: 20%;
    -webkit-flex-basis: 20%;
    flex-basis: 20%;
    max-width: 20%;
  }
`;

const AboutServicesCustomersTermsColumn = styled.div`
  padding-bottom: 20px;

  //col-xs-12
  -ms-flex-preferred-size: 100%;
  -webkit-flex-basis: 100%;
  flex-basis: 100%;
  max-width: 100%;
  // col-md-3
  @media only screen and (min-width: 768px) {
    -ms-flex-preferred-size: 25%;
    -webkit-flex-basis: 25%;
    flex-basis: 25%;
    max-width: 25%;
  }
  @media only screen and (min-width: 992px) {
    -ms-flex-preferred-size: 20%;
    -webkit-flex-basis: 20%;
    flex-basis: 20%;
    max-width: 20%;
  }
`;

const MutedText = css`
  font-size: 12px;
  color: #9ba1a6;
`;

const GetAppText = styled.p`
  font-size: 14px;
  margin-bottom: 5px;
  opacity: 0.5;
`;

const AppLinks = styled.div`
  margin: 110px 0 0 0;

  @media only screen and (max-width: 991px) {
    margin: 40px 0;
  }
`;

const AppLink = styled.a`
  display: inline-block;
  width: 100%;
  font-size 14px;
  margin: 8px 0 0 0;
  color: #525975;
  img {
    display: inline;
    margin: 0 5px 0 0;
  }
`;

const SectionHeader = styled.h6`
  font: 500 18px/1.45 Graphik, sans-serif;
  color: #1d2c4c;
  font-size: 16px;
  margin: 0 0 20px 0;
`;

const Sitemap = styled.ul`
  list-style: none;
  padding-left: 0;
  margin: 0;
  li {
    margin-top: 10px;
  }
  li a {
    color: #525975;
    font-size: 14px;
  }
`;

const BottomContainer = styled.div`
  @media only screen and (min-width: 992px) {
    -ms-flex-preferred-size: 25%;
    -webkit-flex-basis: 25%;
    flex-basis: 25%;
    max-width: 25%;
  }

  -ms-flex-preferred-size: 100%;
  -webkit-flex-basis: 100%;
  flex-basis: 100%;
  max-width: 100%;
`;

const Spacer = styled.div`
  @media only screen and (min-width: 992px) {
    -ms-flex-preferred-size: 8.333333%;
    -webkit-flex-basis: 8.333333%;
    flex-basis: 8.333333%;
    max-width: 8.333333%;
  }

  -ms-flex-preferred-size: 100%;
  -webkit-flex-basis: 100%;
  flex-basis: 100%;
  max-width: 100%;
`;

const FairHousing = styled.img`
  height: 45px;
  @media (max-width: 767px) {
    margin-top: 20px;
    height: 35px;
    float: none;
  }
`;

const SocialLinks = styled.div`
  @media only screen and (min-width: 992px) {
    -ms-flex-preferred-size: 25%;
    -webkit-flex-basis: 25%;
    flex-basis: 25%;
    max-width: 25%;
  }

  -ms-flex-preferred-size: 100%;
  -webkit-flex-basis: 100%;
  flex-basis: 100%;
  max-width: 100%;
`;

const SocialLink = styled.a`
  display: inline-block;
  margin-right: 15px;
  opacity: 0.3;
`;

const hiddenXxsDown = css`
  @media (max-width: 480px) {
    display: none !important;
  }
`;

const hiddenSmDown = css`
  @media (max-width: 991px) {
    display: none !important;
  }
`;
const FullFooter: React.FC = () => {
  return (
    <FooterWrapper>
      <FooterContainer>
        <Row>
          <LogoAppColumn>
            <a href="/">
              <img
                src="https://images.opendoor.com/source/s3/imgdrop-production/logo-opendoor.svg?preset=square-2048"
                alt="Opendoor"
                height={25}
                className="opendoor-logo"
              />
            </a>
            <p css={MutedText}>© {new Date().getFullYear()}</p>
            <AppLinks>
              <GetAppText>Get the app</GetAppText>
              <AppLink
                href="https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&hl=en"
                target="_blank"
              >
                <img
                  src="https://images.opendoor.com/source/s3/imgdrop-production/android-logo.svg?preset=square-2048"
                  height={12}
                  alt="Download for Andriod"
                />
                <span>Download for Android</span>
              </AppLink>
              <AppLink
                href="https://itunes.apple.com/us/app/opendoor-homes-all-day-open/id1143708068?mt=8"
                target="_blank"
              >
                <img
                  src="https://images.opendoor.com/source/s3/imgdrop-production/apple-logo.svg?preset=square-2048"
                  height={12}
                  alt="Download for iOS"
                />
                <span>Download for iOS</span>
              </AppLink>
            </AppLinks>
          </LogoAppColumn>
          <AboutServicesCustomersTermsColumn>
            <SectionHeader>Services</SectionHeader>
            <Sitemap>
              <li>
                <a href="/">Sell your home</a>
              </li>
              <li>
                <a href="https://www.opendoor.com/w/homes">Buy a home</a>
              </li>
              <li>
                <a href="https://www.opendoor.com/w/home-value">Home value</a>
              </li>
            </Sitemap>
          </AboutServicesCustomersTermsColumn>
          <AboutServicesCustomersTermsColumn css={hiddenXxsDown}>
            <SectionHeader>About</SectionHeader>
            <Sitemap>
              <li>
                <a href="https://www.opendoor.com/w/about">About</a>
              </li>
              <li>
                <a href="https://www.opendoor.com/w/contact-us">Contact us</a>
              </li>
              <li>
                <a href="/jobs">Jobs</a>
              </li>
              <li>
                <a href="https://help.opendoor.com/hc/en-us">FAQ</a>
              </li>
              <li>
                <a href="https://www.opendoor.com/w/press">Press</a>
              </li>
              <li>
                <a href="https://www.opendoor.com/w/blog">Blog</a>
              </li>
            </Sitemap>
          </AboutServicesCustomersTermsColumn>
          <AboutServicesCustomersTermsColumn css={hiddenXxsDown}>
            <SectionHeader>Customers</SectionHeader>
            <Sitemap>
              <li>
                <a href="/">For home sellers</a>
              </li>
              <li>
                <a href="https://www.opendoor.com/w/homes">For home buyers</a>
              </li>
              <li>
                <a href="https://www.opendoor.com/w/agents">For real estate agents</a>
              </li>
              <li>
                <a href="https://www.opendoor.com/reviews">Reviews</a>
              </li>
              <li>
                <a href="https://www.opendoor.com/w/stories">Stories</a>
              </li>
              <li>
                <a href="https://www.opendoor.com/w/resources">Resources</a>
              </li>
            </Sitemap>
          </AboutServicesCustomersTermsColumn>
          <AboutServicesCustomersTermsColumn>
            <SectionHeader>Terms & Privacy</SectionHeader>
            <Sitemap>
              <li>
                <a href="https://www.opendoor.com/w/safety">Trust & Safety</a>
              </li>
              <li>
                <a href="https://www.opendoor.com/w/terms">Terms of Service</a>
              </li>
              <li>
                <a href="https://www.opendoor.com/w/privacy">Privacy Policy</a>
              </li>
              <li>
                <a href="https://opendoor-privacy.relyance.ai/">Do Not Sell My Info</a>
              </li>
            </Sitemap>
          </AboutServicesCustomersTermsColumn>
        </Row>
        <Row
          css={css`
            justify-content: space-between;
            margin-top: 80px;
            @media (max-width: 991px) {
              margin-top: 30px;
            }
          `}
        >
          <BottomContainer>
            <FairHousing
              alt="Equal Opportunity Housing Logo"
              src="https://images.opendoor.com/source/s3/imgdrop-production/2cfd25967a794adabcc97873553da5ab.png?preset=square-2048"
            />
          </BottomContainer>
          <Spacer css={hiddenSmDown} />
          <SocialLinks>
            <SocialLink
              href="https://www.facebook.com/OpendoorHQ"
              target="_blank"
              className="social-link"
            >
              <img
                src="https://images.opendoor.com/source/s3/imgdrop-production/facebook-icon.svg?preset=square-2048"
                alt="Opendoor on Facebook"
                width={20}
              />
            </SocialLink>
            <SocialLink href="https://twitter.com/Opendoor" target="_blank" className="social-link">
              <img
                src="https://images.opendoor.com/source/s3/imgdrop-production/twitter-icon.svg?preset=square-2048"
                alt="Opendoor on Twitter"
                width={20}
              />
            </SocialLink>
            <SocialLink
              href="https://www.linkedin.com/company/opendoor-com"
              target="_blank"
              className="social-link"
            >
              <img
                src="https://images.opendoor.com/source/s3/imgdrop-production/linkedin-icon.svg?preset=square-2048"
                alt="Opendoor on LinkedIn"
                width={20}
              />
            </SocialLink>
            <SocialLink
              href="https://www.instagram.com/opendoor/"
              target="_blank"
              className="social-link"
            >
              <img
                src="https://images.opendoor.com/source/s3/imgdrop-production/instagram-icon.svg?preset=square-2048"
                alt="Opendoor on Instagram"
                width={20}
              />
            </SocialLink>
            <SocialLink
              href="https://www.pinterest.com/opendoorhq/"
              target="_blank"
              className="social-link"
            >
              <img
                src="https://images.opendoor.com/source/s3/imgdrop-production/pinterest-icon.svg?preset=square-2048"
                alt="Opendoor on Pinterest"
                width={20}
              />
            </SocialLink>
          </SocialLinks>
        </Row>
      </FooterContainer>
    </FooterWrapper>
  );
};

export default FullFooter;
